import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import './Notification.less';

const Notification = () => <ToastContainer position="top-center" autoClose={3500} newestOnTop draggable={false} />;

export const notify = Object.assign((content, options) => toast(content, options), { ...toast });

notify.success = (content, options) =>
  toast.success(content, {
    position: 'bottom-left',
    className: 'notify-toast',
    ...options,
  });

notify.info = (content, options) =>
  toast.info(content, {
    position: 'bottom-left',
    className: 'notify-toast',
    ...options,
  });

notify.error = (content, options) =>
  toast.error(content, {
    autoClose: false,
    hideProgressBar: true,
    className: 'notify-toast',
    ...options,
  });

notify.warn = (content, options) =>
  toast.warn(content, {
    autoClose: false,
    hideProgressBar: true,
    className: 'notify-toast',
    ...options,
  });

export default Notification;



// WEBPACK FOOTER //
// ./src/components/common/Notification/Notification.jsx